var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Circle_Red_Blue",
    "data-name": "Logo Circle Red Blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16834",
    "data-name": "Path 16834",
    d: "M26.2,23.483A22.86,22.86,0,0,0,35.141,0,37.407,37.407,0,0,0,1.1,24.564a22.86,22.86,0,0,0,25.1-1.081Z",
    transform: "translate(1.174)",
    fill: "#c6252c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16835",
    "data-name": "Path 16835",
    d: "M21.129,28.663A22.86,22.86,0,0,0,1.511,12.91,37.407,37.407,0,0,0,14.4,52.894a22.86,22.86,0,0,0,6.733-24.231Z",
    transform: "translate(-0.006 15.17)",
    fill: "#1e3d71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16836",
    "data-name": "Path 16836",
    d: "M29.535,26.2A23.535,23.535,0,0,0,7.85,39.978a39.353,39.353,0,0,0,43.179.145A23.521,23.521,0,0,0,29.535,26.2Z",
    transform: "translate(8.453 29.498)",
    fill: "#1e3d71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16837",
    "data-name": "Path 16837",
    d: "M46.092,13A22.86,22.86,0,0,0,33.021,52.922,37.157,37.157,0,0,0,46.092,13Z",
    transform: "translate(28.414 15.265)",
    fill: "#1e3d71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16838",
    "data-name": "Path 16838",
    d: "M27.719,23.546a22.86,22.86,0,0,0,25.1,1.247A37.407,37.407,0,0,0,18.929,0a22.86,22.86,0,0,0,8.791,23.546Z",
    transform: "translate(20.955)",
    fill: "#1e3d71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhaLogo);
export default __webpack_public_path__ + "static/media/AHA-logo.4a553b550ef25cd306ee940cc409c284.svg";
export { ForwardRef as ReactComponent };